module.exports = "//static.hsappstatic.net/LoginUI/static-1.14046/img/hubspotMobileApp2FA.png"